// translations/pages/landing/fr.js

export const landingPageFR = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Des solutions d’IA locales centrées sur la protection des données",
    "vision": "Le prochain palier de productivité : l’Organisation as a Service. Des collaborateurs IA prennent le travail en charge de l’idée au résultat vérifié.",
    "intro": "Nous recherchons, développons et intégrons des technologies d’intelligence artificielle, d’apprentissage automatique et de traitement des données. Il en résulte nos propres produits et des solutions sur mesure qui analysent, structurent, anonymisent et protègent les données localement — ainsi qu’avec [Veridion](veridion), des collaborateurs IA entièrement automatisés qui prennent en charge, avec les humains, des domaines entiers de l’entreprise.",
    "detail": "Les logiciels que nous installons chez le client fonctionnent dans sa propre infrastructure et ne nécessitent aucune connexion au cloud. Les documents, les données et les modèles de langage restent dans l’entreprise."
  },
  "partners": {
    "title": "Des partenaires qui nous font confiance",
    "subtitle": "Entreprises et institutions de recherche au sein desquelles notre organisation d’IA est exploitée en production.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nSolutions d’oculométrie et de biosignaux pour votre recherche",
        "description": [
          "BiSigma est spécialisée dans les systèmes de mesure et d’analyse des biosignaux ainsi que dans les solutions d’oculométrie (eye-tracking) de haute précision pour la science, la clinique et la recherche industrielle.",
          "pAIoneer Labs GmbH a entièrement remplacé chez BiSigma le développement logiciel par l’IA, qui développe avec succès et fait évoluer en continu des logiciels de mesure et d’analyse des biosignaux."
        ],
        "cta": "Visiter BiSigma"
      }
    }
  },
  "products": {
    "title": "Produits",
    "subtitle": "Nous vendons des logiciels sous forme d’applications de bureau pour le poste de travail, de logiciels serveur sur site ou dans le cloud du client, et d’abonnements sur notre plateforme, comme l’[assistant de trading](finance), que nos collaborateurs IA développent eux-mêmes. Nous construisons aussi des systèmes d’IA selon les exigences de nos clients, et nous proposons du conseil et des formations.",
    "partnerLabel": "Produit partenaire",
    "priceOnRequest": "Prix sur demande",
    "request": "Envoyer une demande",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil détecte et anonymise les données personnelles dans les fichiers Word, Excel, OpenDocument, PDF et texte avant qu’ils ne soient transmis à des outils d’IA, à des tests, à des analyses ou à des tiers. La détection combine {presidio}, {spacy} et {flair} et fonctionne en allemand, en anglais, en français, en italien et en espagnol.",
          "La version de bureau fonctionne de manière autonome sur des ordinateurs courants sous Windows, macOS ou Linux, sans GPU et sans dépendance au réseau ; les fichiers ne quittent pas le poste de travail. La version API est exploitée dans l’infrastructure du client, sur site ou dans son propre cloud, et intègre l’anonymisation dans les systèmes et les flux de travail existants.",
          "Le mode Replace remplace les données personnelles par des marqueurs pour la documentation de conformité, le mode Fake par des valeurs de substitution plausibles pour les environnements de test ; la structure du document est conservée. Avec AnonChat, un document anonymisé n’est transmis à ChatGPT, Claude, Gemini ou à un modèle de langage interne qu’après un aperçu."
        ],
        "cta": "Découvrir Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Un créateur, une infinité de solutions.",
        "text": [
          "L’IA d’entreprise de pAIoneer Labs GmbH : elle pilote l’entreprise tout entière, en tant qu’organisation complète de collaborateurs IA, avec des business units qui vont du développement logiciel aux ventes et à l’administration, en passant par l’électronique et l’informatique quantique, conduites par leur propre couche de coordination.",
          "Cet effectif mène à leur terme, de façon autonome, les projets, la comptabilité, le savoir de l’entreprise, la recherche, le développement et l’analyse de données. Sa communication est optimisée par la théorie des jeux, et quand il lui faut une capacité qui n’existe pas encore, il construit pour cela son propre système d’IA.",
          "L’organisation est exploitée sur site, dans votre propre cloud ou sur notre plateforme. Elle y développe elle-même l’[assistant de trading](finance) et en est l’IA dans le chat."
        ],
        "points": [
          "S’intègre à chaque processus",
          "Apprend de manière autonome",
          "Crée elle-même les capacités manquantes",
          "Planifiable en cycles fixes"
        ],
        "cta": "Découvrir Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy est un système d’agents modulaire fondé sur l’IA, destiné aux entreprises, qui automatise les tâches administratives de bureau.",
          "Cinq rôles couvrent le quotidien professionnel : l’assistant coordonne les rendez-vous, rédige des e-mails et accomplit les tâches quotidiennes. Le coach accompagne les aspects émotionnels et sociaux de la vie professionnelle, aide en cas de conflit et soutient le développement personnel. L’assistant à la protection des données répond aux questions spécialisées sur la protection des données et la vie privée et peut être entraîné à d’autres domaines spécialisés, comme la protection contre l’incendie ou la conformité. Le formateur élabore des plans de formation continue, des parcours d’intégration et des modules de formation, et le conseiller analyse les documents téléversés, aide à la prise de décision et formule des recommandations stratégiques.",
          "RoBuddy est hébergé et administré à 100 % selon les normes allemandes (RGPD, BSI-Grundschutz) et se raccorde sans difficulté à Nextcloud ou à tout lecteur réseau.",
          "RoBuddy est le système agentique pour le travail de bureau et peut être relié à Veridion pour former une IA d’entreprise qui couvre toute l’entreprise : RoBuddy prend en charge les tâches au poste de travail, Veridion raccorde les systèmes et les données de l’entreprise."
        ],
        "cta": "Découvrir RoBuddy",
        "vendorNote": "RoBuddy est un produit de Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. La distribution est assurée par pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "Plateforme SaaS",
    "description": "Vous utilisez cette application par abonnement directement dans le navigateur, sans installation. Elle fonctionne sur notre propre plateforme, la connexion exige un second facteur, et tous les appels à l’IA passent par un point d’accès central avec des quotas fixes.",
    "apps": {
      "finance": {
        "name": "Assistant de trading IA",
        "text": "Vous connectez votre compte-titres, posez en langage naturel vos questions sur vos positions et voyez quelles informations ont fait bouger les cours. Pour chaque instrument financier, un modèle d’apprentissage automatique dédié, réentraîné chaque jour, calcule la prévision, et un automate peut exécuter les signaux. L’assistant est développé par nos collaborateurs IA ; dans le chat, ils sont aussi son IA.",
        "cta": "Découvrir l’assistant de trading"
      }
    }
  },
  "services": {
    "title": "Services clés",
    "veridion": {
      "title": "Collaborateurs IA",
      "description": "Des champs de travail entiers, occupés par des collaborateurs IA qui s’intègrent aux processus et aux outils de l’entreprise et mènent le travail à son terme de façon autonome. C’est ainsi que nous travaillons nous-mêmes : la pAIoneer Labs GmbH tourne dessus.",
      "cta": "Découvrir Veridion",
      "features": [
        "Organisation as a Service",
        "Business units de collaborateurs IA",
        "Communication optimisée par la théorie des jeux",
        "Sur site ou dans votre propre cloud"
      ]
    },
    "custom": {
      "title": "Systèmes d’IA sur mesure",
      "description": "Nous développons, selon les exigences du client, des systèmes d’analyse, de traitement, de structuration, d’anonymisation et de protection des données et les intégrons dans des infrastructures informatiques locales ou propres au client.",
      "features": [
        "Exploitation sans cloud",
        "Développement de produits",
        "Prototypes",
        "Projets de recherche et développement"
      ]
    },
    "dataanalysis": {
      "title": "Analyse de données en conversation",
      "description": "Un collaborateur IA répond aux questions posées aux sources de données connectées. Il lit les catalogues, les schémas et les colonnes des bases de données, présente un plan d’analyse avant d’accéder aux données et lève les ambiguïtés.",
      "features": [
        "Sources de données SQL",
        "Corrélation et régression",
        "Tableaux et graphiques",
        "Export PDF et PowerPoint"
      ]
    },
    "memory": {
      "title": "Mémoire d’entreprise",
      "description": "Une mémoire au lieu d’une recherche documentaire : faits, décisions, tâches et procédures, reliés aux projets, aux personnes, aux systèmes et aux documents auxquels ils appartiennent, avec la période pendant laquelle ils s’appliquent. Elle grandit d’elle-même à partir des conversations, des réunions et des résultats de travail ; une décision plus récente remplace l’ancienne sur le même sujet, rien ne se perd.",
      "features": [
        "Graphe de connaissances",
        "Faits avec leur temps",
        "Décisions, jamais perdues",
        "Accès selon la responsabilité"
      ]
    },
    "elektronik": {
      "title": "Électronique & firmware",
      "description": "Le développement au plus près du matériel comme prestation : conception de circuits et simulation en jumeau numérique, firmware jusqu’au capteur, évaluation des composants et de leurs alternatives avant toute fabrication.",
      "features": [
        "Jumeaux numériques",
        "Firmware embarqué",
        "Analyse de fiches techniques",
        "Évaluation de composants"
      ]
    },
    "quantum": {
          "title": "LLM Souverains & IA Quantique",
          "description": "Notre objectif sous Veridion : développer des modèles de langage compacts Made in Germany qui rivaliseront avec les grands modèles américains et chinois, ainsi que nos Quantum Transformers.",
          "cta": "Voir Quantum",
          "features": [
                "LLM Made in Germany",
                "Quantum Transformers",
                "Quantum IDE propre",
                "L'IA développe l'IA"
          ]
    },
    "kyveil": {
      "title": "Anonymisation locale sans GPU",
      "description": "Kyveil anonymise les données personnelles en local, sous forme d’application de bureau sur des ordinateurs courants sous Windows, macOS ou Linux ou sous forme d’API REST dans l’infrastructure du client, sans dépendance au cloud et sans GPU.",
      "cta": "Découvrir Kyveil",
      "features": [
        "Anonymisation avant l’IA",
        "Détection NLP des PII",
        "Windows, macOS, Linux",
        "API REST sur site"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "Le développement logiciel assisté par l’IA a besoin d’un contexte fiable. IDD consigne les objectifs, les non-objectifs, les scénarios, les règles d’agents et les décisions sous la forme d’une mémoire de projet exploitable.",
      "cta": "Découvrir IDD",
      "features": [
        "Développement agentique",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Les scénarios comme tests"
      ]
    },
    "finance": {
      "title": "Finance et analyse de marché",
      "description": "Derrière l’assistant de trading se tient une business unit dédiée, composée de collaborateurs numériques : des data scientists IA et des experts en finance. Ils évaluent les actualités en temps réel, analysent les émotions des nouvelles financières et effectuent eux-mêmes, dans le chat, des calculs sur les données de marché : corrélations, régressions, graphiques et bilan de leurs propres prévisions, chaque chiffre provenant d’une étape de calcul exécutée. En dessous fonctionnent une prévision par apprentissage automatique pour chaque instrument financier et le trading automatique sur compte fictif et en réel.",
      "cta": "Voir la page Finance",
      "features": [
        "Data scientists IA & experts en finance",
        "Actualités en temps réel, avec analyse des émotions",
        "Prévision ML par instrument financier",
        "Trading automatique"
      ]
    },
    "consulting": {
      "title": "Conseil",
      "description": "Nous conseillons sur les plans technique, organisationnel et stratégique pour l’introduction de l’IA, sa sécurisation et son utilisation conforme aux règles.",
      "features": [
        "Gouvernance de l’IA",
        "Gestion des données",
        "Protection des données",
        "Sécurité de l’information"
      ]
    }
  },
  "contact": {
    "title": "Contact",
    "addressLabel": "Adresse",
    "phoneLabel": "Téléphone",
    "emailLabel": "E-mail",
    "cta": "Écrire un message"
  }
};
